module.exports = __webpack_public_path__ + "img/avatar6.8544d283.png";